import Badge from '@repo/ui/badge'
import Checkbox from '@repo/ui/checkbox'
import InnerBox from '@repo/ui/inner-box'
import Input from '@repo/ui/input'
import { useEffect, useState } from 'react'

import { TripProperties } from '../../../../lib/types/models/trip/properties.trip'
import { TripPlaceToCenterRequestInput } from '../../../../lib/types/models/trip-place-to-center-request/trip-place-to-center-request-input'

type Props = {
  maxNumberOfStudents: number
  minNumberOfStudents: number
  checkForErrors?: boolean
  tripPlaceToCenterRequest: TripPlaceToCenterRequestInput
  onTripToCenterRequestChange: (tripPlaceToCenterRequest: TripPlaceToCenterRequestInput) => void
}

const TripDetails = ({
  maxNumberOfStudents,
  minNumberOfStudents,
  tripPlaceToCenterRequest,
  onTripToCenterRequestChange
}: Props) => {
  const [numberOfStudents, setNumberOfStudents] = useState(
    tripPlaceToCenterRequest.numberOfStudentsPlacesRequested
  )
  const [numberOfStaffs, setNumberOfStaffs] = useState(
    tripPlaceToCenterRequest.numberOfStaffPlacesRequested ?? 0
  )

  useEffect(() => {
    const timer = setTimeout(() => {
      onTripToCenterRequestChange({
        ...tripPlaceToCenterRequest,
        numberOfStudentsPlacesRequested: numberOfStudents,
        numberOfStaffPlacesRequested: numberOfStaffs
      })
    }, 500)

    return () => clearTimeout(timer)
  }, [numberOfStudents, numberOfStaffs])

  useEffect(() => {
    setNumberOfStudents(tripPlaceToCenterRequest.numberOfStudentsPlacesRequested)
    setNumberOfStaffs(tripPlaceToCenterRequest.numberOfStaffPlacesRequested ?? 0)
  }, [
    tripPlaceToCenterRequest.numberOfStudentsPlacesRequested,
    tripPlaceToCenterRequest.numberOfStaffPlacesRequested
  ])

  return (
    <InnerBox className="bg-white-hover p-4 rounded-lg gap-4">
      <div className="flex items-center gap-4">
        <div className="flex flex-col gap-2">
          <Badge
            variant="primary"
            text={TripProperties.getTripLabel(tripPlaceToCenterRequest.trip)}
          />
          <Badge
            text={
              minNumberOfStudents !== maxNumberOfStudents
                ? `min ${minNumberOfStudents} - max: ${maxNumberOfStudents}`
                : `${maxNumberOfStudents} jeunes`
            }
          />
        </div>

        <Input
          type="number"
          labelClassName="bg-white-hover"
          label="Nombre max jeunes"
          required
          value={numberOfStudents}
          onChange={(e) => setNumberOfStudents(Number(e.target.value))}
        />

        <Input
          type="number"
          label="Nombre encadrants"
          labelClassName="bg-white-hover"
          required
          value={numberOfStaffs}
          onChange={(e) => setNumberOfStaffs(Number(e.target.value))}
        />
      </div>
      <Checkbox
        label="Ne pas appliquer les restrictions"
        checked={tripPlaceToCenterRequest.disableRestriction}
        onChange={() => {
          onTripToCenterRequestChange({
            ...tripPlaceToCenterRequest,
            disableRestriction: !tripPlaceToCenterRequest.disableRestriction
          })
        }}
      />
    </InnerBox>
  )
}

export default TripDetails
